export default __webpack_public_path__ + "static/media/Demonlink Wristbands.dceb8ca3.jpg";